import { render, staticRenderFns } from "./ProductEditGroups.vue?vue&type=template&id=09d93fd2"
import script from "./ProductEditGroups.vue?vue&type=script&lang=ts"
export * from "./ProductEditGroups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09d93fd2')) {
      api.createRecord('09d93fd2', component.options)
    } else {
      api.reload('09d93fd2', component.options)
    }
    module.hot.accept("./ProductEditGroups.vue?vue&type=template&id=09d93fd2", function () {
      api.rerender('09d93fd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditGroups.vue"
export default component.exports